/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatsDemoRouteImport } from './routes/stats-demo'
import { Route as SoundLabRouteImport } from './routes/sound-lab'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as HowToPlayRouteImport } from './routes/how-to-play'
import { Route as GameroomsRouteImport } from './routes/gamerooms'
import { Route as GameroomRouteImport } from './routes/gameroom'
import { Route as AccoladesDemoRouteImport } from './routes/accolades-demo'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CollectionsIndexRouteImport } from './routes/collections/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as CollectionsNewRouteImport } from './routes/collections/new'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AdminTopicsIndexRouteImport } from './routes/admin/topics/index'
import { Route as AdminLobbiesIndexRouteImport } from './routes/admin/lobbies/index'
import { Route as AdminCollectionsIndexRouteImport } from './routes/admin/collections/index'
import { Route as CollectionsIdEditRouteImport } from './routes/collections/$id.edit'
import { Route as AdminTopicsAgentRouteImport } from './routes/admin/topics/agent'
import { Route as AdminTopicsIdRouteImport } from './routes/admin/topics/$id'
import { Route as AdminSlotsIdRouteImport } from './routes/admin/slots/$id'
import { Route as AdminLobbiesIdRouteImport } from './routes/admin/lobbies/$id'
import { Route as AdminCollectionsIdRouteImport } from './routes/admin/collections/$id'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsDemoRoute = StatsDemoRouteImport.update({
  id: '/stats-demo',
  path: '/stats-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const SoundLabRoute = SoundLabRouteImport.update({
  id: '/sound-lab',
  path: '/sound-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const HowToPlayRoute = HowToPlayRouteImport.update({
  id: '/how-to-play',
  path: '/how-to-play',
  getParentRoute: () => rootRouteImport,
} as any)
const GameroomsRoute = GameroomsRouteImport.update({
  id: '/gamerooms',
  path: '/gamerooms',
  getParentRoute: () => rootRouteImport,
} as any)
const GameroomRoute = GameroomRouteImport.update({
  id: '/gameroom',
  path: '/gameroom',
  getParentRoute: () => rootRouteImport,
} as any)
const AccoladesDemoRoute = AccoladesDemoRouteImport.update({
  id: '/accolades-demo',
  path: '/accolades-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const CollectionsNewRoute = CollectionsNewRouteImport.update({
  id: '/collections/new',
  path: '/collections/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTopicsIndexRoute = AdminTopicsIndexRouteImport.update({
  id: '/topics/',
  path: '/topics/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLobbiesIndexRoute = AdminLobbiesIndexRouteImport.update({
  id: '/lobbies/',
  path: '/lobbies/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCollectionsIndexRoute = AdminCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const CollectionsIdEditRoute = CollectionsIdEditRouteImport.update({
  id: '/collections/$id/edit',
  path: '/collections/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTopicsAgentRoute = AdminTopicsAgentRouteImport.update({
  id: '/topics/agent',
  path: '/topics/agent',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTopicsIdRoute = AdminTopicsIdRouteImport.update({
  id: '/topics/$id',
  path: '/topics/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSlotsIdRoute = AdminSlotsIdRouteImport.update({
  id: '/slots/$id',
  path: '/slots/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLobbiesIdRoute = AdminLobbiesIdRouteImport.update({
  id: '/lobbies/$id',
  path: '/lobbies/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCollectionsIdRoute = AdminCollectionsIdRouteImport.update({
  id: '/collections/$id',
  path: '/collections/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/accolades-demo': typeof AccoladesDemoRoute
  '/gameroom': typeof GameroomRoute
  '/gamerooms': typeof GameroomsRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sound-lab': typeof SoundLabRoute
  '/stats-demo': typeof StatsDemoRoute
  '/terms': typeof TermsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/collections/new': typeof CollectionsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/admin/collections/$id': typeof AdminCollectionsIdRoute
  '/admin/lobbies/$id': typeof AdminLobbiesIdRoute
  '/admin/slots/$id': typeof AdminSlotsIdRoute
  '/admin/topics/$id': typeof AdminTopicsIdRoute
  '/admin/topics/agent': typeof AdminTopicsAgentRoute
  '/collections/$id/edit': typeof CollectionsIdEditRoute
  '/admin/collections/': typeof AdminCollectionsIndexRoute
  '/admin/lobbies/': typeof AdminLobbiesIndexRoute
  '/admin/topics/': typeof AdminTopicsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accolades-demo': typeof AccoladesDemoRoute
  '/gameroom': typeof GameroomRoute
  '/gamerooms': typeof GameroomsRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sound-lab': typeof SoundLabRoute
  '/stats-demo': typeof StatsDemoRoute
  '/terms': typeof TermsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/collections/new': typeof CollectionsNewRoute
  '/admin': typeof AdminIndexRoute
  '/collections': typeof CollectionsIndexRoute
  '/admin/collections/$id': typeof AdminCollectionsIdRoute
  '/admin/lobbies/$id': typeof AdminLobbiesIdRoute
  '/admin/slots/$id': typeof AdminSlotsIdRoute
  '/admin/topics/$id': typeof AdminTopicsIdRoute
  '/admin/topics/agent': typeof AdminTopicsAgentRoute
  '/collections/$id/edit': typeof CollectionsIdEditRoute
  '/admin/collections': typeof AdminCollectionsIndexRoute
  '/admin/lobbies': typeof AdminLobbiesIndexRoute
  '/admin/topics': typeof AdminTopicsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/accolades-demo': typeof AccoladesDemoRoute
  '/gameroom': typeof GameroomRoute
  '/gamerooms': typeof GameroomsRoute
  '/how-to-play': typeof HowToPlayRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sound-lab': typeof SoundLabRoute
  '/stats-demo': typeof StatsDemoRoute
  '/terms': typeof TermsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/collections/new': typeof CollectionsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/admin/collections/$id': typeof AdminCollectionsIdRoute
  '/admin/lobbies/$id': typeof AdminLobbiesIdRoute
  '/admin/slots/$id': typeof AdminSlotsIdRoute
  '/admin/topics/$id': typeof AdminTopicsIdRoute
  '/admin/topics/agent': typeof AdminTopicsAgentRoute
  '/collections/$id/edit': typeof CollectionsIdEditRoute
  '/admin/collections/': typeof AdminCollectionsIndexRoute
  '/admin/lobbies/': typeof AdminLobbiesIndexRoute
  '/admin/topics/': typeof AdminTopicsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/accolades-demo'
    | '/gameroom'
    | '/gamerooms'
    | '/how-to-play'
    | '/leaderboard'
    | '/login'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/sound-lab'
    | '/stats-demo'
    | '/terms'
    | '/auth/callback'
    | '/collections/new'
    | '/admin/'
    | '/collections/'
    | '/admin/collections/$id'
    | '/admin/lobbies/$id'
    | '/admin/slots/$id'
    | '/admin/topics/$id'
    | '/admin/topics/agent'
    | '/collections/$id/edit'
    | '/admin/collections/'
    | '/admin/lobbies/'
    | '/admin/topics/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accolades-demo'
    | '/gameroom'
    | '/gamerooms'
    | '/how-to-play'
    | '/leaderboard'
    | '/login'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/sound-lab'
    | '/stats-demo'
    | '/terms'
    | '/auth/callback'
    | '/collections/new'
    | '/admin'
    | '/collections'
    | '/admin/collections/$id'
    | '/admin/lobbies/$id'
    | '/admin/slots/$id'
    | '/admin/topics/$id'
    | '/admin/topics/agent'
    | '/collections/$id/edit'
    | '/admin/collections'
    | '/admin/lobbies'
    | '/admin/topics'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/accolades-demo'
    | '/gameroom'
    | '/gamerooms'
    | '/how-to-play'
    | '/leaderboard'
    | '/login'
    | '/privacy'
    | '/profile'
    | '/register'
    | '/sound-lab'
    | '/stats-demo'
    | '/terms'
    | '/auth/callback'
    | '/collections/new'
    | '/admin/'
    | '/collections/'
    | '/admin/collections/$id'
    | '/admin/lobbies/$id'
    | '/admin/slots/$id'
    | '/admin/topics/$id'
    | '/admin/topics/agent'
    | '/collections/$id/edit'
    | '/admin/collections/'
    | '/admin/lobbies/'
    | '/admin/topics/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AccoladesDemoRoute: typeof AccoladesDemoRoute
  GameroomRoute: typeof GameroomRoute
  GameroomsRoute: typeof GameroomsRoute
  HowToPlayRoute: typeof HowToPlayRoute
  LeaderboardRoute: typeof LeaderboardRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  SoundLabRoute: typeof SoundLabRoute
  StatsDemoRoute: typeof StatsDemoRoute
  TermsRoute: typeof TermsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CollectionsNewRoute: typeof CollectionsNewRoute
  CollectionsIndexRoute: typeof CollectionsIndexRoute
  CollectionsIdEditRoute: typeof CollectionsIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats-demo': {
      id: '/stats-demo'
      path: '/stats-demo'
      fullPath: '/stats-demo'
      preLoaderRoute: typeof StatsDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sound-lab': {
      id: '/sound-lab'
      path: '/sound-lab'
      fullPath: '/sound-lab'
      preLoaderRoute: typeof SoundLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-to-play': {
      id: '/how-to-play'
      path: '/how-to-play'
      fullPath: '/how-to-play'
      preLoaderRoute: typeof HowToPlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gamerooms': {
      id: '/gamerooms'
      path: '/gamerooms'
      fullPath: '/gamerooms'
      preLoaderRoute: typeof GameroomsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gameroom': {
      id: '/gameroom'
      path: '/gameroom'
      fullPath: '/gameroom'
      preLoaderRoute: typeof GameroomRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accolades-demo': {
      id: '/accolades-demo'
      path: '/accolades-demo'
      fullPath: '/accolades-demo'
      preLoaderRoute: typeof AccoladesDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/': {
      id: '/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof CollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/collections/new': {
      id: '/collections/new'
      path: '/collections/new'
      fullPath: '/collections/new'
      preLoaderRoute: typeof CollectionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/topics/': {
      id: '/admin/topics/'
      path: '/topics'
      fullPath: '/admin/topics/'
      preLoaderRoute: typeof AdminTopicsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lobbies/': {
      id: '/admin/lobbies/'
      path: '/lobbies'
      fullPath: '/admin/lobbies/'
      preLoaderRoute: typeof AdminLobbiesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/collections/': {
      id: '/admin/collections/'
      path: '/collections'
      fullPath: '/admin/collections/'
      preLoaderRoute: typeof AdminCollectionsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/collections/$id/edit': {
      id: '/collections/$id/edit'
      path: '/collections/$id/edit'
      fullPath: '/collections/$id/edit'
      preLoaderRoute: typeof CollectionsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/topics/agent': {
      id: '/admin/topics/agent'
      path: '/topics/agent'
      fullPath: '/admin/topics/agent'
      preLoaderRoute: typeof AdminTopicsAgentRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/topics/$id': {
      id: '/admin/topics/$id'
      path: '/topics/$id'
      fullPath: '/admin/topics/$id'
      preLoaderRoute: typeof AdminTopicsIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/slots/$id': {
      id: '/admin/slots/$id'
      path: '/slots/$id'
      fullPath: '/admin/slots/$id'
      preLoaderRoute: typeof AdminSlotsIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lobbies/$id': {
      id: '/admin/lobbies/$id'
      path: '/lobbies/$id'
      fullPath: '/admin/lobbies/$id'
      preLoaderRoute: typeof AdminLobbiesIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/collections/$id': {
      id: '/admin/collections/$id'
      path: '/collections/$id'
      fullPath: '/admin/collections/$id'
      preLoaderRoute: typeof AdminCollectionsIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCollectionsIdRoute: typeof AdminCollectionsIdRoute
  AdminLobbiesIdRoute: typeof AdminLobbiesIdRoute
  AdminSlotsIdRoute: typeof AdminSlotsIdRoute
  AdminTopicsIdRoute: typeof AdminTopicsIdRoute
  AdminTopicsAgentRoute: typeof AdminTopicsAgentRoute
  AdminCollectionsIndexRoute: typeof AdminCollectionsIndexRoute
  AdminLobbiesIndexRoute: typeof AdminLobbiesIndexRoute
  AdminTopicsIndexRoute: typeof AdminTopicsIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminCollectionsIdRoute: AdminCollectionsIdRoute,
  AdminLobbiesIdRoute: AdminLobbiesIdRoute,
  AdminSlotsIdRoute: AdminSlotsIdRoute,
  AdminTopicsIdRoute: AdminTopicsIdRoute,
  AdminTopicsAgentRoute: AdminTopicsAgentRoute,
  AdminCollectionsIndexRoute: AdminCollectionsIndexRoute,
  AdminLobbiesIndexRoute: AdminLobbiesIndexRoute,
  AdminTopicsIndexRoute: AdminTopicsIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AccoladesDemoRoute: AccoladesDemoRoute,
  GameroomRoute: GameroomRoute,
  GameroomsRoute: GameroomsRoute,
  HowToPlayRoute: HowToPlayRoute,
  LeaderboardRoute: LeaderboardRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  SoundLabRoute: SoundLabRoute,
  StatsDemoRoute: StatsDemoRoute,
  TermsRoute: TermsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CollectionsNewRoute: CollectionsNewRoute,
  CollectionsIndexRoute: CollectionsIndexRoute,
  CollectionsIdEditRoute: CollectionsIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
